export default "__VITE_ASSET__DQyiZbP2__"